import { enums } from "shared";
import { useClassNames } from "shared/hooks";
import Text from "components/UI/Text";
import styles from "./styles.module.scss";
import {
  ChangeEventHandler,
  FocusEventHandler,
  MouseEventHandler,
  forwardRef,
  ReactNode,
} from "react";

type InputType = {
  label?: ReactNode;
  labelColor?: string;
  className?: string;
  name: string;
  type: string;
  required?: boolean;
  placeholder?: ReactNode;
  marginRight?: boolean;
  isContainerWidth?: boolean;
  value?: string;
  isOutlined?: boolean;
  iconPath?: string;
  appendIconPath?: string;
  autoCompleteOff?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onFocus?: FocusEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  onClick?: MouseEventHandler<HTMLInputElement>;
};

const CustomInput = forwardRef<HTMLInputElement, InputType>(
  (
    {
      label,
      labelColor,
      className,
      name,
      type,
      required,
      placeholder,
      marginRight,
      value,
      isContainerWidth,
      isOutlined,
      iconPath,
      appendIconPath,
      autoCompleteOff,
      readOnly,
      disabled,
      onChange,
      onFocus,
      onBlur,
      onClick,
    },
    ref
  ) => {
    const { MD } = enums.SIZE;

    const classNames = useClassNames([
      styles.CustomInput,
      marginRight ? styles["CustomInput--marginRight"] : "",
      isContainerWidth ? styles["CustomInput--wideContainer"] : "",
      isOutlined ? styles["CustomInput--outlined"] : "",
      iconPath ? styles["CustomInput--hasIcon"] : "",
      appendIconPath ? styles["CustomInput--hasAppendIcon"] : "",
      disabled ? styles["CustomInput--disabled"] : "",
      className || "",
    ]);
    const inputFieldClassNames = useClassNames([
      styles["CustomInput-inputField"],
      label ? styles["CustomInput-inputField--marginTop"] : "",
    ]);

    return (
      <div className={classNames}>
        {label && (
          <Text noMargin size={MD} sx={{ color: labelColor }}>
            {label}
          </Text>
        )}
        <div className={styles["CustomInput-inputFieldContainer"]}>
          {!!iconPath && (
            <img
              src={iconPath}
              alt="icon"
              className={styles["CustomInput-icon"]}
            />
          )}
          <input
            autoComplete={autoCompleteOff ? "off" : undefined}
            name={name}
            type={type}
            className={inputFieldClassNames}
            placeholder={typeof placeholder === "string" ? placeholder : ""}
            value={value}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            onClick={onClick}
            readOnly={readOnly}
            disabled={disabled}
            required={required}
            ref={ref}
          />
          {appendIconPath && (
            <img
              src={appendIconPath}
              alt="icon"
              className={styles["CustomInput-appendIcon"]}
            />
          )}
        </div>
      </div>
    );
  }
);

export default CustomInput;
